export default "__VITE_ASSET__CgbzbNtd__"